export const FIELD_LOG_KEY = 'field-log' as const;

/** Bounded page size for active-scroll pagination without eagerly draining cursors. */
export const FIELD_LOG_PAGE_LIMIT = 50;

/** Smaller History page size keeps route-entry and active-scroll requests lightweight. */
export const FIELD_LOG_HISTORY_PAGE_LIMIT = 15;

/** Organization options are a compact permission-scoped picker source. */
export const FIELD_LOG_ORGANIZATION_OPTIONS_PAGE_LIMIT = 100;

/** API-enforced maximum number of exact filenames in one footage lookup. */
export const FIELD_LOG_FOOTAGE_LOOKUP_MAX_FILENAMES = 200;

/** Maximum number of session rows that can be submitted from the visit editor. */
export const FIELD_LOG_VISIT_EDITOR_BATCH_LIMIT = 100;

/**
 * Where the client-side camera roster is persisted.
 *
 * TRANSITIONAL. The contract derives a visit's `cameras` from the sessions that
 * exist, so a camera brought to a visit but not yet rolled has nowhere on the wire
 * to live. The planned set is therefore kept here.
 */
export const FIELD_LOG_CAMERA_ROSTER_STORAGE_KEY = 'vl-field-log:camera-roster:v1';

/** One successful new-visit camera roster per user and organization. */
export const FIELD_LOG_LAST_CAMERAS_STORAGE_KEY = 'vl-field-log:last-cameras:v1';

/** Browser-local new-visit Organization shortcuts, kept separately per user. */
export const FIELD_LOG_NEW_VISIT_ORGANIZATION_RECENT_SCOPE = {
  pickerKey: 'field-log-new-visit:organization',
} as const;
